export default __webpack_public_path__ + "static/media/ae.68e81433.svg";